type LocaleTimeZones = Intl.Locale & { getTimeZones?: () => string[] };

type ResolveOptions = {
  locale: string;
  supportedCodes: string[];
  timeZone?: string;
  countryTimeZones?: (countryCode: string) => string[];
};

// CLDR data straight from the engine, so every country the backend supports is
// covered without a hand-written map. Missing outside Chromium/Safari, hence [].
const countryTimeZonesFromIntl = (countryCode: string): string[] => {
  try {
    const locale = new Intl.Locale(`und-${countryCode}`) as LocaleTimeZones;
    return locale.getTimeZones?.() ?? [];
  } catch {
    return [];
  }
};

// "cs-CZ" carries the region, "cs" does not — a bare language is no signal
const countryFromLocale = (locale: string): string | undefined => {
  const region = locale.split("-")[1];
  return region ? region.toUpperCase() : undefined;
};

const resolveInitialCountryCode = ({
  countryTimeZones = countryTimeZonesFromIntl,
  locale,
  supportedCodes,
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
}: ResolveOptions): string => {
  const fromTimeZone = supportedCodes.find((code) =>
    countryTimeZones(code).includes(timeZone),
  );

  const guesses = [fromTimeZone, countryFromLocale(locale)];

  return guesses.find((code) => !!code && supportedCodes.includes(code)) ?? "";
};

export { resolveInitialCountryCode };
